import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import tracking from 'dibs-tracking';
import { connect } from 'react-redux';
import { trackPreRegistrationPageVisit } from 'dibs-visit-tracking/exports/sourceAttribution';
import { getBuyerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';
import get from 'lodash.get';
import { cdnTestTracking } from '../utils/tracking/searchBrowse/cdnTestTracking';

class SharedTrackingContainerComponent extends React.Component {
    static getDerivedStateFromProps(newProps, prevState) {
        if (newProps.visitCount > prevState.visitCount) {
            return {
                trackingInitialized: false,
                visitCount: newProps.visitCount,
            };
        }

        return null;
    }

    constructor() {
        super();
        this.state = {
            trackingInitialized: false,
            visitCount: 0,
        };
    }

    componentDidMount() {
        const userId = getBuyerId(document.cookie);
        /**
         * No user id on mount? Means the user is logged out and we can safely fire off tracking.
         */
        if (!userId && this.shouldFireTracking(this.props)) {
            this.fireTracking();
        }
    }

    componentDidUpdate() {
        if (this.shouldFireTracking()) {
            this.fireTracking();
        }
    }

    fireTracking(props = this.props) {
        const { onTrackingFired, additional } = props;
        let { gtmPageInfo } = props;

        if (get(serverVars, 'youMayAlsoLikeNC') === 'test') {
            gtmPageInfo = {
                ...gtmPageInfo,
                additional: { ...gtmPageInfo.additional, cdnTest2: 'youMayAlsoLike - test' },
            };
        } else if (get(serverVars, 'youMayAlsoLikeNC') === 'control') {
            gtmPageInfo = {
                ...gtmPageInfo,
                additional: { ...gtmPageInfo.additional, cdnTest2: 'youMayAlsoLike - control' },
            };
        }

        if (additional) {
            const currentAdditional = gtmPageInfo.additional || {};

            gtmPageInfo = {
                ...gtmPageInfo,
                additional: {
                    ...currentAdditional,
                    ...additional,
                    ...cdnTestTracking(),
                },
            };
        }

        trackPreRegistrationPageVisit();
        tracking.trackPageview(gtmPageInfo);
        this.setState({
            trackingInitialized: true,
        });
        onTrackingFired();
    }

    shouldFireTracking() {
        /**
         * if we're fetching user but have no user data, wait until that returns before
         * firing tracking
         */
        const { fetchUser, user, isClient, gtmPageInfo } = this.props;
        const waitingForUserData = fetchUser && !user;
        return !waitingForUserData && gtmPageInfo && !this.state.trackingInitialized && isClient;
    }

    render() {
        return null;
    }
}

SharedTrackingContainerComponent.propTypes = {
    onTrackingFired: PropTypes.func,
    relay: PropTypes.object.isRequired,
    user: PropTypes.object,
    gtmPageInfo: PropTypes.object,
    isClient: PropTypes.bool.isRequired,
    fetchUser: PropTypes.bool.isRequired,
    currency: PropTypes.string.isRequired,
    visitCount: PropTypes.number,
    additional: PropTypes.object,
};

SharedTrackingContainerComponent.defaultProps = {
    onTrackingFired: () => {},
    visitCount: 0,
};

SharedTrackingContainerComponent.contextTypes = {
    relay: PropTypes.shape({
        variables: PropTypes.object,
    }),
};

function mapStateToProps(state) {
    const {
        relayVariables: { variables },
    } = state;
    return {
        isClient: variables.isClient,
        fetchUser: variables.fetchUser,
    };
}

export const SharedTrackingContainer = createFragmentContainer(
    connect(mapStateToProps)(SharedTrackingContainerComponent),
    {
        user: graphql`
            fragment SharedTrackingContainer_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
    }
);
